import * as React from 'react';
import {Helmet} from 'react-helmet';
// @ts-expect-error
import {ContextRouter} from 'react-router-dom';

import {SubmissionError} from 'redux-form';

import {formEncodedApi} from 'nutshell-core/api';
import {Routing} from 'nutshell-core/routing';
import {makeErrorObject} from 'nutshell-core/validation/make-error-object';
import {
    validationErrorCheck,
    ValidationError,
} from 'nutshell-core/validation/validation-error-check';

import {headTitle} from 'shells/document/head-title';

import {ForgotPasswordForm} from './forgot-password-form';

export function ForgotPasswordPage(props: ContextRouter) {
    const [successMsg, setSuccessMsg] = React.useState<any>(null);
    const params = Routing.deparam(props.location.search);
    const username = params ? params.email : '';

    return (
        <React.Fragment>
            <Helmet>
                <title>{headTitle('Reset password')}</title>
            </Helmet>
            <ForgotPasswordForm
                // @ts-expect-error
                successMessage={successMsg}
                initialValues={{username}}
                // @ts-expect-error
                onSubmit={(data) =>
                    handleSubmit(data).then((res) => {
                        if (res && res.success) {
                            setSuccessMsg(res.message);
                        }
                    })
                }
            />
        </React.Fragment>
    );
}

// @ts-expect-error
function handleSubmit(formData) {
    return (
        formEncodedApi
            .post(
                '/auth/forgot-password.json',
                {username: formData.username},
                {headers: {accept: 'application/json'}}
            )
            // @ts-expect-error
            .then(validationErrorCheck)
            // @ts-expect-error
            .then((res) => res.json())
            .catch((err: Error) => {
                // @ts-expect-error
                if (err instanceof ValidationError && err.validationResult) {
                    throw new SubmissionError(makeErrorObject(err));
                }
            })
    );
}
